module.exports = __webpack_public_path__ + "static/media/Slice1.0a08fa70.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/Slice1.png
// module id = 1508
// module chunks = 0